// extracted by mini-css-extract-plugin
export default {"tab":"TotalsNav_tab__eZ+1M","users":"TotalsNav_users__WjtgE"};